import * as Yup from 'yup'

export default Yup.object().shape({
  username: Yup.string()
    .email(`screens.login.sections.formErrors.userEmail`)
    .required(`screens.login.sections.formErrors.userRequired`),
  password: Yup.string()
    .required(`screens.login.sections.formErrors.passwordRequired`),
})